<template>
	<div class="open-pay">
		<div class="business-body">
			<div style="color:red;">温馨提示：请联系项目经理进行商户认证信息报备，报备通过后再提交资质信息</div>
            <el-form :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" label-position='left' label-width="130px" class="box">
				<div class="open-title">
					<span>主体类型</span>
				</div>
				<el-form-item label="主体类型:" prop='businessRegisterType'>
                    <el-select v-model="ruleForm.businessRegisterType" size='mini' class='select-box region'>
                        <el-option label="企业" :value="0"></el-option>
						<el-option label="个体工商户" :value="1"></el-option>
                    </el-select>
                </el-form-item>
				<div class="open-title">
                    <span>经营信息</span>
                </div>
                <el-form-item label="商户名称:" prop='merchantName'>
                    <el-input class='input-box' size='mini' v-model="ruleForm.merchantName" :maxlength='128'></el-input>
                </el-form-item>
                <el-form-item label="社会信用代码:" prop='uniﬁedSocialCreditCode'>
                    <el-input class='input-box' size='mini' v-model="ruleForm.uniﬁedSocialCreditCode" :maxlength='18'></el-input>
                </el-form-item>
				<el-form-item label="营业执照照片:" prop='picture'>
                    <div class='business-picture'>
						<uploadBox
						class="banner-img"
						@save='save'
						@isFalse='isFalse'
						@saveImgData="saveImgData"
						@delete="deleteImgData"
						:imgSrc.sync="ruleForm.imgurl"
						:dataid= "ruleForm.id"
						:uploadError.sync="uploadError"
						ref="bannerUpload"></uploadBox>
					</div>
                </el-form-item>
				<el-form-item label="营业执照有效期:" prop='businessDate1'>
                    <div class="time-limit">
						<el-date-picker
							v-model="ruleForm.businessDate1"
							type="date"
							class="time-input"
							size="small"
							placeholder="开始日期"
							format='yyyy-MM-dd'
							value-format='yyyy-MM-dd'>
						</el-date-picker>
						<el-radio v-model="ruleForm.businessPeriod" @change="bpChange" :label="0">有效期至</el-radio>
						<el-date-picker
							v-model="ruleForm.businessDate2"
							type="date"
							class="time-input"
							size="small"
							placeholder="结束日期"
							format='yyyy-MM-dd'
							value-format='yyyy-MM-dd'>
						</el-date-picker>
						<el-radio v-model="ruleForm.businessPeriod" @change="bpChange" :label="1">不限</el-radio>
					</div>
                </el-form-item>
				<div class="open-title">
                    <span>经营者信息</span>
                </div>
                <el-form-item label="姓名:" prop='legalPersonName'>
                    <el-input class='input-box' size='mini' v-model="ruleForm.legalPersonName" :maxlength='128'></el-input>
                </el-form-item>
				<el-form-item label="身份证照片:">
                     <div class='business-picture'>
						<div style="display:flex">
							<uploadBox
							style="margin-right:20px"
							class="banner-img"
							@save='save'
							@isFalse='isFalse'
							@saveImgData="saveImgData1"
							@delete="deleteImgData1"
							:imgSrc.sync="ruleForm.imgurl"
							:dataid= "ruleForm.id"
							:uploadError.sync="uploadError"
							ref="bannerUpload"></uploadBox>
							<uploadBox
							class="banner-img"
							@save='save'
							@isFalse='isFalse'
							@saveImgData="saveImgData2"
							@delete="deleteImgData2"
							:imgSrc.sync="ruleForm.imgurl"
							:dataid= "ruleForm.id"
							:uploadError.sync="uploadError"
							ref="bannerUpload"></uploadBox>
						</div>
					</div>
                </el-form-item>
				<el-form-item label="身份证有效期:" prop='idPeriod'>
                    <div class="time-limit">
						<el-date-picker
							v-model="ruleForm.idDate1"
							type="date"
							class="time-input"
							size="small"
							placeholder="开始日期"
							format='yyyy-MM-dd'
							value-format='yyyy-MM-dd'>
						</el-date-picker>
						<el-radio v-model="ruleForm.idPeriod" :label="0">有效期至</el-radio>
						<el-date-picker
							v-model="ruleForm.idDate2"
							type="date"
							class="time-input"
							size="small"
							placeholder="结束日期"
							format='yyyy-MM-dd'
							value-format='yyyy-MM-dd'>
						</el-date-picker>
						<el-radio v-model="ruleForm.idPeriod" :label="1">不限</el-radio>
					</div>
                </el-form-item>
                <el-form-item label="身份证号码:" prop='legalPersonCardNumber'>
                    <el-input class='input-box' size='mini' v-model="ruleForm.legalPersonCardNumber" :maxlength='18'></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop='mobileNumber'>
                    <el-input  class='input-box' size='mini' v-model="ruleForm.mobileNumber" :maxlength='11'></el-input>
                </el-form-item>
				<div class="open-title">
					<span>收款账户</span>
				</div>
				<el-form-item label="账户类型:" prop='accountType'>
                    <el-select v-model="ruleForm.accountType" size='mini' class='select-box region'>
                        <el-option label="企业" :value="0"></el-option>
						<el-option label="个人" :value="1"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="开户名称:" prop='bankAccountName'>
                    <el-input  class='input-box' size='mini' v-model="ruleForm.bankAccountName" :maxlength='128'></el-input>
                </el-form-item>
				<el-form-item label="银行账户:" prop='bankAccountNumber'>
                    <el-input  class='input-box' size='mini' v-model="ruleForm.bankAccountNumber" :maxlength='64'></el-input>
                </el-form-item>
				<el-form-item label="开户银行:" prop='bankName'>
					<el-input  class='input-box' size='mini' v-model="ruleForm.bankName" :maxlength='128'></el-input>
                </el-form-item>
				<el-form-item label="开户银行联行号:" :prop="ruleForm.accountType === 0 ? 'bankBranchId' : ''">
                    <el-input  class='input-box' size='mini' v-model="ruleForm.bankBranchId" :maxlength='128'></el-input>
                </el-form-item>
                <el-form-item label="开户支行:" :prop="ruleForm.accountType === 0 ? 'bankBranchName' : ''">
                    <el-input  class='input-box' size='mini' v-model="ruleForm.bankBranchName" :maxlength='128'></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="business-foot">
            <el-button class="btn" plain type="default" size='mini' @click="cancel">返回</el-button>
            <el-button class="btn" type="primary" size='mini' @click="submitForm('ruleForm')">确认</el-button>
        </div>
	</div>
</template>

<script>
import uploadBox from '@/components/weiPayList/Upload.vue'
export default {
	name: 'business',
	components: {
		uploadBox
	},
	data () {
		var phone = (rule, value, callback) => {
			var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!(reg.test(value))) {
				return callback(new Error('请输入正确的手机号'))
			} else {
				callback()
			}
		}
		var legalPersonCardNumber = (rule, value, callback) => {
			var reg = /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$/
			if (!(reg.test(value))) {
				return callback(new Error('请输入正确的身份证号码'))
			} else {
				callback()
			}
		}
		var isNull = (rule, value, callback) => {
			var reg = /^[\s\S]*.*[^\s][\s\S]*$/
			if (!(reg.test(value))) {
				return callback(new Error(''))
			} else {
				callback()
			}
		}
		var isPicture = (rule, value, callback) => {
			if (!this.ruleForm.businessLicenseImageId) {
				return callback(new Error('请上传营业执照照片'))
			} else {
				callback()
			}
		}
		var businessDate1 = (rule, value, callback) => {
			var begintime = this.ruleForm.businessDate1
			var endtime = this.ruleForm.businessDate2
			let sixtyDate = 5184000000 // 60天时间戳
			let differenceDate = new Date(endtime).getTime() - new Date(begintime).getTime()
			if (!this.ruleForm.businessDate1 || (this.ruleForm.businessPeriod === 0 && !this.ruleForm.businessDate2)) {
				return callback(new Error('请选择营业执照有效期'))
			} else if (this.ruleForm.businessPeriod === 0 && (differenceDate < sixtyDate)) {
				return callback(new Error('请选择大于60天的有效期限'))
			} else {
				callback()
			}
		}
		var idPeriod = (rule, value, callback) => {
			var begintime = this.ruleForm.idDate1
			var endtime = this.ruleForm.idDate2
			if (!this.ruleForm.idDate1 || (this.ruleForm.idPeriod === 0 && !this.ruleForm.idDate2)) {
				return callback(new Error('请选择身份证有效期'))
			} else if (this.ruleForm.idPeriod === 0 && (new Date(endtime).getTime() < new Date(begintime).getTime())) {
				return callback(new Error('请选择正确的有效期限'))
			} else {
				callback()
			}
		}
		var bankBranchId = (rule, value, callback) => {
			if (this.ruleForm.accountType === 0 && !this.ruleForm.bankBranchId && !this.ruleForm.bankBranchName) {
				return callback(new Error('请输入开户银行联行号'))
			} else {
				callback()
			}
		}
		var bankBranchName = (rule, value, callback) => {
			if (this.ruleForm.accountType === 0 && !this.ruleForm.bankBranchId && !this.ruleForm.bankBranchName) {
				return callback(new Error('请输入开户支行'))
			} else {
				callback()
			}
		}
		return {
			AuthorityList: {
				'01_0002_0001_00': false
			},
			clddock: '',
			src: '',
			area: '',
			province: '',
			city: '',
			uploadError: false,
			provinceListTotal: [],
			provinceList: [],
			cityList: [],
			areaList: [],
			regionList: [],
			isTrue: true,
			isWaring: false,
			waringArea: true,
			imgId: '',
			dateValue: [],
			ruleForm: {
				businessRegisterType: 0,
				accountType: 0,
				businessPeriod: 0,
				idPeriod: 0,
				businessDate1: '',
				businessDate2: '',
				idDate1: '',
				idDate2: '',
				businessLicenseValidityPeriod: [],
				legalPersonCardValidityPeriod: [],
				bankName: '',
				merchantName: '',
				legalPersonName: '',
				legalPersonCardNumber: '',
				uniﬁedSocialCreditCode: '',
				bankAccountName: '',
				businessLicenseImageId: '',
				legalPersonCardFrontImageId: null,
				legalPersonCardBackImageId: null,
				imgurl: '',
				id: '',
				bankAccountNumber: '',
				bankBranchName: '',
				bankBranchId: ''
			},
			rules: {
				businessRegisterType: [
					{ required: true, message: '请选择主体类型', trigger: 'blur' }
				],
				accountType: [
					{ required: true, message: '请选择账户类型', trigger: 'blur' }
				],
				bankName: [
					{ required: true, validator: isNull, message: '请输入开户银行', trigger: 'blur' }
				],
				merchantName: [
					{ required: true, validator: isNull, message: '请输入商户名称', trigger: 'blur' }
				],
				legalPersonName: [
					{ required: true, validator: isNull, message: '请输入经营者姓名', trigger: 'blur' }
				],
				legalPersonCardNumber: [
					{ required: true, validator: legalPersonCardNumber, trigger: 'blur' }
				],
				idPeriod: [
					{ required: true, validator: idPeriod, trigger: ['change', 'blur'] }
				],
				uniﬁedSocialCreditCode: [
					{ required: true, validator: isNull, message: '请输入社会信用代码', trigger: 'blur' },
					{ min: 18, max: 18, message: '社会信用代码长度为18个字符', trigger: 'blur' }
				],
				bankAccountName: [
					{ required: true, validator: isNull, message: '请输入开户名称', trigger: 'blur' }
				],
				bankAccountNumber: [
					{ required: true, validator: isNull, message: '请输入银行账户', trigger: 'blur' }
				],
				bankBranchId: [
					{ required: true, validator: bankBranchId, message: '请输入开户银行联行号', trigger: 'blur' }
				],
				bankBranchName: [
					{ required: true, validator: bankBranchName, message: '请输入开户支行', trigger: 'blur' }
				],
				picture: [
					{ required: true, validator: isPicture, trigger: 'blur' }
				],
				businessDate1: [
					{ required: true, validator: businessDate1, trigger: ['change', 'blur'] }
				],
				email: [
					{ type: 'email', required: true, message: '请输入正确的邮箱', trigger: 'blur' }
				],
				mobileNumber: [
					{ required: true, validator: phone, trigger: 'blur' }
				]
			},
			fxDataVerification: this.$fxUtils.fxDataVerification()
		}
	},
	created () {
		this.getAuthority('01_0002_0000_00')
	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		bpChange () {
			this.$refs.ruleForm.validateField('businessDate1', (val) => {
				if (!val) {
					return true
				} else {
					return false
				}
			})
		},
		cancel () {
			this.$emit('dialogClose')
		},
		isFalse (data) {
			if (data === true) {
				this.$message.error('请上传图片')
			}
		},
		saveImgData (data) {
			this.ruleForm.businessLicenseImageId = data
		},
		saveImgData1 (data) {
			this.ruleForm.legalPersonCardFrontImageId = data
		},
		saveImgData2 (data) {
			this.ruleForm.legalPersonCardBackImageId = data
		},
		deleteImgData (data) {
			this.ruleForm.businessLicenseImageId = ''
		},
		deleteImgData1 (data) {
			this.ruleForm.legalPersonCardFrontImageId = null
		},
		deleteImgData2 (data) {
			this.ruleForm.legalPersonCardBackImageId = null
		},
		save () {
			if (this.ruleForm.businessPeriod === 0) {
				this.ruleForm.businessLicenseValidityPeriod = [this.ruleForm.businessDate1, this.ruleForm.businessDate2]
			} else {
				this.ruleForm.businessLicenseValidityPeriod = [this.ruleForm.businessDate1, '长期']
			}
			if (this.ruleForm.idPeriod === 0) {
				if (this.ruleForm.idDate1 && this.ruleForm.idDate2) {
					this.ruleForm.legalPersonCardValidityPeriod = [this.ruleForm.idDate1, this.ruleForm.idDate2]
				}
			} else {
				if (this.ruleForm.idDate1) {
					this.ruleForm.legalPersonCardValidityPeriod = [this.ruleForm.idDate1, '长期']
				}
			}
			let copyForm = this.$fxUtils.deepClone(this.ruleForm)
			if (!copyForm.bankBranchId) {
				delete copyForm.bankBranchId
			}
			if (!copyForm.bankBranchName) {
				delete copyForm.bankBranchName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlSV}/shop/tenpay/productapplication/open`,
				data: copyForm
			}).then(res => {
				if (res.result) {
					this.getUrl(res.data)
				} else {
					this.$message.error(res.msg)
					if (res.code === 1008) {
						this.$emit('refreshClose')
					}
				}
			})
		},
		getUrl (data) {
			this.$store.dispatch('requestPost', {
				url: `/quickorder/ns/v1/shop/tenpay/productapplication/link/${data}`
			}).then(res => {
				if (res.result) {
					this.$fxGoBlank(res.data.pc_web.url)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			originData.areaName = this.getAreaName(originData.area)
			originData.positionName = this.getPositionName(originData)
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			ruleForm.areaName = this.getAreaName(ruleForm.area)
			ruleForm.positionName = this.getPositionName(ruleForm)
			return {
				pre: originData,
				cur: ruleForm
			}
		},
		getAreaName (code) {
			if (!code) {
				return ''
			}
			return (this.areaList.find(item => {
				return item.code === code
			}) || {}).name
		},
		getPositionName ({ province, city }) {
			if (!province || !city) {
				return ''
			}
			const _province = (this.provinceList.find(item => {
				return item.id === province
			}) || {}).name
			const _city = (this.cityList.find(item => {
				return item.id === city
			}) || {}).name
			return `${_province}-${_city}`
		},
		submitForm (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.save()
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.open-pay{
    width :100%;
    height :65vh;
    display: flex;
	flex-direction: column;
	border-top: 1px solid #eee;
	padding-top: 20px
	.open-title {
		color: #333;
		font-weight: bold;
		font-size: 15px;
		margin: 10px 0;
	}
    .star{
        color: #F56C6C;
        margin-right: 4px;
        width:10px;
        position: relative;
        right: 292px;
        top: 26px;
    }
    .waring{
        height :14px;
        color: #F56C6C;
        font-size: 12px;
        position: relative;
        text-align :left;
        padding-left :110px;
        bottom: 20px;
    }
    .business-body{
        height :100%;
        overflow-y :auto;
        margin-bottom :20px;
        padding-bottom :30px;
        .business-picture{
            text-align:center;
			padding-top: 10px;
			.time-limit {
				text-align: left;
				margin-top: 10px
			}
        }
        .box{
            width :700px
            .input-box{
                width :200px;
            }
            .input-box-address{
                 width :500px;
            }
            .select-box{
                width :200px;
                // margin-right :20px;
            }
            .select-box1{
                width :200px;
            }
            .el-form-item >>> .el-form-item__content{
                text-align :left
                }
        }
    }
	.time-input {
		width: 170px;
		margin-right: 30px
	}
    .business-foot{
        position: relative;
        height :40px;
        width :100%;
		text-align: right;
        .btn{
            width :80px;
			height :35px;
			margin-left :20px;
        }
    }
}
</style>
<style lang="stylus">
	.el-textarea__inner {
		font-family: 'Microsoft Yahei' !important
	}
</style>
